"use strict";

/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module calls
 */

module.exports = function (config, get, post) {
	/**
	 * Asks the server to call a user on our behalf
	 * @param  {String} to    User id to call
	 * @return {Promise}      Resolves to object containing room
	 */
	function call(to, reason, voiceOnly, metadata) {
		return post("/v2/call", {
			to: to,
			reason: reason,
			voiceOnly: voiceOnly,
			metadata: metadata
		});
	}

	/**
	 * Creates a new conference call
	 * @param  {String} to    The person this call is directed towards
	 * @param  {String} other The other person participating in the call
	 * @return {Promise}       Resolves to an object that contains a `room`
	 */
	function conference(to, other, voiceOnly) {
		return post("/v2/call/conference", {
			to: to,
			other: other,
			voiceOnly: voiceOnly
		});
	}

	/**
	 * Gets list of missed calls.
	 * Returns and array of objects {from: , _id:}
	 * @return {Promise}      Resolves to array of object containing `from` and the call `_id`
	 */
	function missed() {
		return get("/v2/call/missed", {});
	}

	/**
	 * Marks calls from a certain person as read
	 * @param  {String}  from Id of the person to read calls from
	 * @return {Promise}      Resolves if marking calls as read succeeded
	 */
	function read(from) {
		return post("/v2/call/read", {
			from: from
		});
	}

	function notifymissed(room) {
		var roomId = room.room;
		return post("/v2/call/notifymissed", {
			room: roomId
		});
	}

	function pending() {
		return get("/v2/call/pending");
	}

	function callstatuses(who){
		return get("/v2/call/callstatuses", {
			who: who
		});
	}

	function inCall(){
		return post("/v2/call/incall");
	}

	function outCall(){
		return post("/v2/call/outcall");
	}

	function silent(to, reason){
		return post("/v2/call/silent", {
			to: to,
			reason: reason
		});
	}

	return {
		call: call,
		conference: conference,
		missed: missed,
		read: read,
		notifymissed: notifymissed,
		pending: pending,
		callstatuses: callstatuses,
		inCall: inCall,
		outCall: outCall,
		silent: silent
	};
};
